<template>
<div id="header" class="header">
  <nav class="nav-container">
    <div class="navbar" :class="{ 'navbar--hidden': !showNavbar && isPC,
    'no-wrap': isPC}">

        <img alt="MKX logo" v-bind:src="require('@/assets/logo-prov.png')"
        class="logoImage">

        <div id="menu-sp-button" class=""
        :class="{'menu-sp-button':!isPC, 'menu-sp-rotate': isOpen}"
        v-on:click="menuClick()">
        </div>

        <div id="menu" class="" :class="{'menu-sp': !isPC,'menu-pc': isPC,
        'open': isOpen, 'close': !isOpen && !isPC}">
          <router-link to="/about">About</router-link>
          <router-link to="/games">Game</router-link>
          <router-link to="/assets">Assets</router-link>
          <router-link to="/team">Staff</router-link>
          <router-link to="/contact">Contact</router-link>
        </div>

				<!--li v-for="(section, index) in $i18n.messages[$i18n.locale].header.sections" :key="index">
                    <a @click="scrolling(index)">{{ section }}</a>
                </li-->
                <!-- Select to change the language of the site -->
                <!-- <LocaleChanger /> -->
        <!--hr /-->
    </div>
    </nav>
    </div>
</template>

<script>
// import LocaleChanger from './LocaleChanger'
export default {
    name: 'Header',
    components: {
        // LocaleChanger
    },
    data () {
        return {
            showNavbar: true,
            lastScrollPosition: 0,
            isPC:true,
            isOpen:false,
        }
    },
    created(){
      this.getUA();
    },
    beforeMount(){
      this.initialize();
    },
    mounted () {
        window.addEventListener('scroll', this.onScroll)
    },
    beforeDestroy () {
        window.removeEventListener('scroll', this.onScroll)
    },
    methods: {

      getUA: function(){
        var uA = navigator.userAgent;
        if( (uA.search('iPhone')!= -1) ||
             (uA.search('iPad') != -1) ||
             (uA.search('Android') != -1)){
          this.isPC = false;
        }
        return uA;
      },
      initialize: function(){

        if(this.isPC){
          console.log("isPC");
        }else{
          console.log("NotPC");
        }
      },
      setNavEV: function(){

      },
      menuClick: function(){
        this.isOpen = !this.isOpen;
      },
        onScroll () {
            const navbarOffset = 20; // value that determines after how many pixels to hide the navbar
            const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop

            // Stop executing this function if
            // 1) The user is not actively scrolling
            // 2) The difference between current scroll position and last scroll position is less the navbarOffset
            if (currentScrollPosition < 0 || Math.abs(currentScrollPosition - this.lastScrollPosition) < navbarOffset ) {
                return
            }
            this.showNavbar = Math.abs(currentScrollPosition < this.lastScrollPosition)
            this.lastScrollPosition = currentScrollPosition
        },
        scrolling (index) {
            var section = this.$i18n.messages['en'].header.sections[index].toLowerCase()
            var sectionPosition = document.getElementById(section).offsetTop
            if (this.lastScrollPosition > sectionPosition) {
                if ((typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1)) {
                    sectionPosition = sectionPosition - 190
                } else {
                    sectionPosition = sectionPosition - 80
                }
            }
            window.scrollTo({top: sectionPosition, behavior: "smooth"});
        }
    }
}
</script>

<style scoped>
.header{
  display: flex;
  height: 0;
}

nav{
  width: 100%;
    display: flex;
}
.menu-pc{
  display: flex;
  flex-shrink: 3;
}
.menu-sp{
  display: flex;
  flex-direction: column;
  flex-basis: 100%;

}
#menu.close{
  display: none;
}
#menu.open{
  display: flex;
}
.menu-sp-button{
  position: absolute;
  background-image: url('~@/assets/triangle.png');
  background-position: center;
  background-size: contain;
  z-index: 200;

  width: 4rem;
  height: 4rem;
  top: 2rem;
  right: 5rem;
}
.menu-sp-rotate{
   transform: rotate(180deg);
}
.navbar.navbar--hidden {
    box-shadow: none;
    transform: translate3d(0, -100%, 0);
}
.navbar {
    background: rgba(0 , 0, 0, 0.6);
    flex-grow: 0;
    display: flex;
    flex-direction: row;
    -padding-top: 15px;
    width: 100%;
    z-index: 200;
    align-items: center;
    -justify-content: space-evenly;
     flex-wrap: wrap;
    position: fixed;
    transform: translate3d(0, 0, 0);
    transition: 0.1s all ease-out;
}
.logoImage{
  width: 15rem;
  height: auto;
}
.sp-logo{
  flex-grow: 3;
}
.nav-container-list{


}
.nav-container-list .locale-changer {
    display: flex;
}
.nav-container{
-width: 100%;
-align-content: center;
-align-self: center;
-flex-shrink: 2;
}

.nav-container a {
    text-align: center;
	padding: .5em 1.5em;
    font-size: 2vw;
    font: bolder;
    text-decoration: none;
    text-transform: uppercase;
    color: #fff;
    border-bottom: none !important;
}
.nav-container a:hover {
    color:#fff;
    -border-bottom: 2px solid #ef4b47 !important;
    text-shadow: 2px 2px 2px #ef4b47 !important;

}

.side-menu{

}

.no-wrap{

    flex-wrap: nowrap;
}

@media only screen and (max-width: 1024px) {

nav-container a:hover {

    border-style: none !important;
  }
  .nav-container{

    padding-bottom: 1rem;
  }
}

@media only screen and (max-width: 750px){

.menu-sp-button{
  width: 2rem;
  height: 2rem;
  top: 2rem;
  right: 1rem;
}
.logoImage {
  width: 10rem;
  }
}

@media only screen and (max-width: 760px) {
  .logoImage {

    }

.navbar{
 justify-content: space-evenly;
}

  .nav-container .menu-pc a{
      font-size: 2vw;
  }
  .nav-container .menu-sp a{
      font-size: 5vw;
  }
  .nav-container a{
    padding: .5em -1em;
    display: flex;
    align-items: center;
    justify-content: center;

  }
  .nav-container-list{

   margin-top: 0px;
  }
}
@media (max-width: 572px){
  .logoImage {
    }

    .nav-container .menu-pc a{
        font-size: 2vw;
    }


}
@media (max-width: 320px) {
  .logoImage {

     height: 6rem;
      width: auto;
  }
  .nav-container{
    margin-right:0 rem;

  }
    .nav-container-list{
        flex-direction: column;

    }

}
</style>
